import { RegisteredNode, RegisteredNodeServerResponse } from './registeredNode.types';

export function adaptToCreate(
  registeredNodeData: RegisteredNode,
): RegisteredNode {
  return registeredNodeData;
}

export function adaptRegisteredNodeList(
  registeredNodeList: RegisteredNode[] | RegisteredNodeServerResponse[],
): RegisteredNode[] {
  return registeredNodeList.map(adaptFromServerFormat);
}

export function adaptSelectedRegisteredNode(
  registeredNodeList: RegisteredNode[] | RegisteredNodeServerResponse[],
): RegisteredNode[] {
  return registeredNodeList.map(adaptFromServerFormat);
}

export function adaptFromServerFormat(
  registeredNodeData: RegisteredNode | RegisteredNodeServerResponse,
): RegisteredNode {

  return {
    id: registeredNodeData.id,
    nodeName: (registeredNodeData as RegisteredNodeServerResponse).NODENAME || (registeredNodeData as RegisteredNode).nodeName,
    siteName: (registeredNodeData as RegisteredNodeServerResponse).SITENAME || (registeredNodeData as RegisteredNode).siteName,
    nodeType: (registeredNodeData as RegisteredNodeServerResponse).NODETYPE || (registeredNodeData as RegisteredNode).nodeType,
    topology: (registeredNodeData as RegisteredNodeServerResponse).TOPOLOGY || (registeredNodeData as RegisteredNode).topology,
    ipAddr: (registeredNodeData as RegisteredNodeServerResponse).IPADDR || (registeredNodeData as RegisteredNode).ipAddr,
    ipAddr6: (registeredNodeData as RegisteredNodeServerResponse).IPADDR6 || (registeredNodeData as RegisteredNode).ipAddr6,
    status: (registeredNodeData as RegisteredNodeServerResponse).STATUS || (registeredNodeData as RegisteredNode).status,
    city: (registeredNodeData as RegisteredNodeServerResponse).CITY || (registeredNodeData as RegisteredNode).city,
    stateName: (registeredNodeData as RegisteredNodeServerResponse).STATENAME || (registeredNodeData as RegisteredNode).stateName,
    country: (registeredNodeData as RegisteredNodeServerResponse).COUNTRY || (registeredNodeData as RegisteredNode).country,
    longitude: (registeredNodeData as RegisteredNodeServerResponse).LONGITUDE || (registeredNodeData as RegisteredNode).longitude,
    latitude: (registeredNodeData as RegisteredNodeServerResponse).LATITUDE || (registeredNodeData as RegisteredNode).latitude,
    swVersion: (registeredNodeData as RegisteredNodeServerResponse).SWVERSION || (registeredNodeData as RegisteredNode).swVersion,
    access: (registeredNodeData as RegisteredNodeServerResponse).ACCESS || (registeredNodeData as RegisteredNode).access,
    group: (registeredNodeData as RegisteredNodeServerResponse).GROUP || (registeredNodeData as RegisteredNode).group,
    owner: (registeredNodeData as RegisteredNodeServerResponse).OWNER || (registeredNodeData as RegisteredNode).owner,
  };
}

export function adaptToServerFormat(
  registeredNodeData: RegisteredNode,
): RegisteredNodeServerResponse {

  return {
    id: registeredNodeData.id,
    NODENAME: registeredNodeData.nodeName,
    SITENAME: registeredNodeData.siteName,
    NODETYPE: registeredNodeData.nodeType,
    TOPOLOGY: registeredNodeData.topology,
    IPADDR: registeredNodeData.ipAddr,
    IPADDR6: registeredNodeData.ipAddr6,
    STATUS: registeredNodeData.status,
    CITY: registeredNodeData.city,
    STATENAME: registeredNodeData.stateName,
    COUNTRY: registeredNodeData.country,
    LONGITUDE: registeredNodeData.longitude,
    LATITUDE: registeredNodeData.latitude,
    SWVERSION: registeredNodeData.swVersion,
    OWNER: registeredNodeData.owner,
    ACCESS: registeredNodeData.access,
    GROUP: registeredNodeData.group,
  };
}
